module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "honor-system"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "height": "560px",
      "src": require("../images/honor_system/banner.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "apply-btn"
  }, [_c('img', {
    attrs: {
      "height": "84px",
      "src": require("../images/honor_system/apply_btn.png"),
      "alt": ""
    },
    on: {
      "click": _vm.onApplyCoreUser
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "benefit-form"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.coreUserRights), function(honor) {
    return _c('div', {
      key: honor.name,
      staticClass: "table-body"
    }, [_c('div', {
      staticClass: "honor-type"
    }, [_vm._v(_vm._s(honor.name))]), _vm._v(" "), _c('div', {
      staticClass: "honor-content"
    }, _vm._l((honor.value), function(honorItem) {
      return _c('div', {
        key: honorItem.rights,
        staticClass: "honor-item"
      }, [_c('div', {
        staticClass: "honor-title",
        attrs: {
          "title": honorItem.rights
        }
      }, [_vm._v(_vm._s(honorItem.rights))]), _vm._v(" "), _c('div', {
        staticClass: "common",
        attrs: {
          "title": honorItem.common_user
        }
      }, [_vm._v(_vm._s(honorItem.common_user))]), _vm._v(" "), _c('div', {
        staticClass: "core",
        attrs: {
          "title": honorItem.core_user
        }
      }, [_vm._v(_vm._s(honorItem.core_user))])])
    }), 0)])
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "whale-count-wrap"
  }, [_c('div', {
    staticClass: "my-whale"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("鲸币要求")]), _vm._v(" "), _c('ul', {
    staticClass: "whale-list"
  }, _vm._l((_vm.whaleList), function(whaleItem) {
    return _c('li', {
      key: whaleItem.bkb,
      staticClass: "whale-item"
    }, [_c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(whaleItem.text))]), _vm._v(" "), _c('p', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.userBalance[whaleItem.bkb]))]), _vm._v(" "), _c('img', {
      staticClass: "whale-badge",
      attrs: {
        "src": whaleItem.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), (_vm.isAllBkb) ? _c('div', {
      staticClass: "schedule",
      style: ({
        'width': _vm.getSchedule(_vm.userBalance[whaleItem.bkb]),
        'background': whaleItem.color
      })
    }) : _vm._e()])
  }), 0), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    staticClass: "ball-left",
    attrs: {
      "src": require("../images/honor_system/ball-left.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ball-right",
    attrs: {
      "src": require("../images/honor_system/ball-right.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "fame-wall"
  }, [_c('ul', {
    staticClass: "user-list"
  }, [_vm._l((_vm.coreUserList), function(user, index) {
    return _c('li', {
      key: index,
      staticClass: "user-item"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": user.profile_photo,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('p', {
      staticClass: "company",
      attrs: {
        "title": user.company
      }
    }, [_vm._v(_vm._s(user.company))]), _vm._v(" "), _c('p', {
      staticClass: "position",
      attrs: {
        "title": user.position
      }
    }, [_vm._v(_vm._s(user.position))]), _vm._v(" "), _c('p', {
      staticClass: "join-time"
    }, [_vm._v("加入时间：" + _vm._s(user.join_time))])])
  }), _vm._v(" "), _c('img', {
    staticClass: "badge-left",
    attrs: {
      "src": require("../images/honor_system/badge.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "badge-right",
    attrs: {
      "src": require("../images/honor_system/badge.png"),
      "alt": ""
    }
  })], 2)]), _vm._v(" "), _c('honorDialog', {
    attrs: {
      "isShow": _vm.isShow
    },
    on: {
      "closeDialog": function($event) {
        _vm.isShow = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "width": "198px",
      "height": "211px",
      "src": require("../images/honor_system/title2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-header"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "rights"
  }, [_vm._v("权益")]), _vm._v(" "), _c('div', {
    staticClass: "common-user"
  }, [_vm._v("普通用户")]), _vm._v(" "), _c('div', {
    staticClass: "core-user"
  }, [_vm._v("核心用户")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "width": "216px",
      "height": "211px",
      "src": require("../images/honor_system/title1.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "more",
    attrs: {
      "href": "https://bk.tencent.com/s-mart/community/question/4022",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("获取更多鲸币")]), _vm._v(" "), _c('img', {
    staticClass: "arrows-right",
    attrs: {
      "height": "36px",
      "width": "36px",
      "src": require("../images/honor_system/arrows-right.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "width": "252px",
      "height": "211px",
      "src": require("../images/honor_system/title3.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-e4b36726!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/honorSystem.vue
// module id = b6Ga
// module chunks = 15